<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/14rWS7o/image/Front.jpg?1718732526858" alt="This image is the cover for the book Little Brown Bear and You"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Little Brown Bear and You
      </h1>
      <p class="bookDescription body article font2">
        <p>Little Bear finds himself lost and alone. He is looking for someone to love. He finds many possible friends along his way but none of them seem to be interested in him. He spends a long, lonely night, but wakes to a wonderful surprise in the morning, you! One of Little Bear’s adventures is a joyful exploration of how he alerts Vadie and Natie to the fact that they forgot to take him to bed with them. The story is told through the limitless scope of a child’s imagination and the delight of rhyme. In Little Bear’s Garden, Bear discovers the fun to be found in growing your own garden and the rewards of eating the wonderful veggies he has grown. All three stories are interactive at the end, inviting young readers to imagine what they would do if they were Little Bear.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan A. Katz
      </h2>
      
      <p class="authorDescription body article">Susan A. Katz is a poet, author, teacher, and workshop facilitator. She is the author of six books of poetry, two textbooks espousing the integration of the arts into school curriculum, numerous articles exploring the benefits of integrated teaching, and has had her poetry appear in national and international magazines, journals, and anthologies. Her venture into the realm of children’s stories was inspired by her seven grandchildren. She wrote Little Bear and You for her granddaughter who was feeling “under loved”. Little Bear took on a life of his own and Susan continues to write her stories, even though her grandchildren are now grown. “Our characters become a part of us,” Susan says, “and it is hard to let them go.”</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?31ed189e